export default __webpack_public_path__ + "static/media/move-arte-3.9fae7738.webp";